export const NPS = 'NPS';
export const YES_NO_ICON_PATH = 'yes_no';
export const NPS_PROMOTERS_INDEX = [9, 10];
export const NPS_DETRACTORS_INDEX = [0, 1, 2, 3, 4, 5, 6];

export const COLORS = {
  MAIN: '#14a5b2',
  POSITIVE: '#219653',
  NEUTRAL: '#f8e67e',
  NEGATIVE: '#c23628',
  BLACK: '#000000',
  WHITE: '#ffffff',
};

export const DEFAULT_RESULTS_TRANSLATION = {
  noEnoughData: 'Not Enough Data',
  allRespondents: 'All Respondents:',
  see: 'See',
  responded: 'Responded',
  comments: 'Comments',
  outOf: 'Out of',
  peopleResponded: 'people responded',
  eNPS: 'eNPS',
  avg: 'Average',
  positive: 'Positive',
  attributeBased: 'Attribute Based',
  positiveSentimentText: 'Positive Sentiment',
  noPositiveSentimentText: 'No Positive Sentiment',
  moreDetails: 'More Details',
};

export const DEFAULT_CHART_TRANSLATION = {
  noCanvasSupport: 'Your browser does not support the canvas element. Bar Chart cannot be displayed.',
};
